<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
      <v-toolbar flat color="white">
        <v-toolbar-title>Payment Status Required Modification</v-toolbar-title>
        <!-- <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider> -->
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          align="center"
        ></v-text-field>
        <v-spacer></v-spacer>
        <!-- view page start here -->
        <v-dialog v-model="dialog">
          <template>
            <v-layout row>
              <v-flex xs12 sm6 offset-sm3>
                <v-container fluid>
                  <v-card>
                    <v-card-title class="indigo white--text">
                      <div class="headline">Transaction Details</div>
                    </v-card-title>
                    <v-card-text>
                      <v-layout row>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">Project ID</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">{{editedItem.project_id}}</v-subheader>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">Client ID</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">{{editedItem.client_id}}</v-subheader>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">Transaction ID</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">{{editedItem.trans_id}}</v-subheader>
                        </v-flex>
                      </v-layout>

                      <v-layout row v-if="editedItem.client_bank_account_no">
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">Account Number</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">{{editedItem.client_bank_account_no}}</v-subheader>
                        </v-flex>
                      </v-layout>

                      <v-layout row v-if="editedItem.client_bank_account_name">
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">Account Number</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">{{editedItem.client_bank_account_name}}</v-subheader>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">Amount</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">{{editedItem.amount}}</v-subheader>
                        </v-flex>
                      </v-layout>

                      <v-layout row v-if="editedItem.trans_date">
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">Transaction Date</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">{{editedItem.trans_date}}</v-subheader>
                        </v-flex>
                      </v-layout>

                      <v-layout row v-if="editedItem.cheque_receive_date">
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">Cheque Receive Date</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">{{editedItem.cheque_receive_date}}</v-subheader>
                        </v-flex>
                      </v-layout>

                      <v-layout row v-if="editedItem.cheque_deposit_date">
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">Cheque Deposited Date</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">{{editedItem.cheque_deposit_date}}</v-subheader>
                        </v-flex>
                      </v-layout>

                      <v-layout row v-if="editedItem.payment_method_id !=null">
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">Payment Method</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">{{editedItem.payment_method_name}}</v-subheader>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">Payment Status</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">{{editedItem.payment_status_name}}</v-subheader>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">Transaction Status</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">{{editedItem.transaction_status_name}}</v-subheader>
                        </v-flex>
                      </v-layout>

                      <v-layout row v-if="editedItem.cheque_or_trans_photo || editedItem.cheque_deposit_photo">
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">Transaction Documents</v-subheader>
                        </v-flex>
                        <v-flex xs6 class="ml-4">
                          <div v-if="editedItem.cheque_or_trans_photo">
                            <a
                            :href=" indexData.transFileUrl + editedItem.cheque_or_trans_photo"
                            target="_blank"
                            >download
                            </a>
                          </div>
                          <div v-if="editedItem.cheque_deposit_photo">
                            <a
                            :href=" indexData.transFileUrl + editedItem.cheque_deposit_photo"
                            target="_blank"
                            >download
                            </a>
                          </div>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-bold">Modification Comment</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                          <v-subheader class="black--text font-weight-regular">{{editedItem.modification_comment}}</v-subheader>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-container>
              </v-flex>
            </v-layout>
            <!-- <v-divider inset></v-divider> -->
            <v-container fluid>
              <v-layout row>
                <div>
                  <v-btn color="red" @click="close">Cancel</v-btn>
                </div>
              </v-layout>
            </v-container>
          </template>
        </v-dialog>
        <!-- view page end here -->
      </v-toolbar>
      <div v-if="alertMsg">
        <v-alert
          v-if="error == 0 && statusCode == 200"
          :value="true"
          type="success"
          transition="slide-y-reverse-transition"
          >{{ errorMsg }}</v-alert
        >
        <v-alert
          v-if="error == 1 && statusCode == 204"
          :value="true"
          type="info"
          transition="slide-y-reverse-transition"
          >{{ errorMsg }}</v-alert
        >
        <v-alert
          v-if="error == 1 && (statusCode == 403 || statusCode == 400)"
          :value="true"
          type="warning"
          transition="slide-y-reverse-transition"
          >{{ errorMsg }}</v-alert
        >
        <v-alert
          v-if="error == 1 && statusCode == 500"
          :value="true"
          type="error"
          transition="slide-y-reverse-transition"
          >{{ errorMsg }}</v-alert
        >
      </div>
    <div v-if="isLoaded">
      <div v-if="indexData.totalModified < 1" class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-data-table
        :headers="headers"
        :items="indexData.modifiedDatas.data"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        hide-actions
        class="elevation-1"
      >
        <v-progress-linear color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>

        <template v-if="indexData.totalModified > 0" v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.project_id }}</td>
          <td>{{ props.item.client_id }}</td>
          <td>{{ props.item.amount }}</td>
          <td>{{ props.item.payment_status_id }}</td>
          <td>{{ props.item.trans_id }}</td>
          <td>{{ props.item.active }}</td>
          <td>{{ props.item.modification_comment }}</td>
          <td class="justify-center layout px-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="checkItem(props.item)"
                >
                  visibility
                </v-icon>
              </template>
              <span>view</span>
            </v-tooltip>
          </td>
        </template>
        <template v-else v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">
            {{ errorMsg }}
          </v-alert>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:pageText>
          Rows {{ indexData.modifiedDatas.from }} -
          {{ indexData.modifiedDatas.to }} of
          {{ indexData.modifiedDatas.total }}
        </template>
      </v-data-table>
      <template>
        <div class="text-xs-center">
          <v-pagination
            v-model="indexData.modifiedDatas.current_page"
            :length="indexData.modifiedDatas.last_page"
            @input="onPageChange"
          ></v-pagination>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false,
    alertMsg: false,
    apiUrl: "payment-status",
    sl: 1,
    headers: [
      { text: "ID", align: "left", value: "id" },
      { text: "Project ID", align: "left", value: "project_id" },
      { text: "Client ID", align: "left", value: "client_id" },
      { text: "Amount", value: "amount" },
      { text: "Payment Status ID", value: "payment_status_id" },
      { text: "Transaction ID", value: "transaction_id" },
      { text: "Active Status", value: "active" },
      { text: "Modification comment", value: "modification_comment" },
      { text: "Actions", align: "center", value: "name", sortable: false },
    ],
    loading: false,
    search: "",
    pagination: {},
    rowsPerPageItems: [5, 10, 20, 50, 100, 200, 500],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    isLoaded() {
      if (this.indexData.modifiedDatas) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
    pagination() {
      this.onPageChange();
    },
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.PendingPaginationMethod();
  },

  methods: {
    initialize() {
      this.$store.dispatch("changePaymentStatus", ["payment-status", 3, "", 1, 5]);

      // this.alertMsg = true
      // setTimeout(() => {
      //   this.alertMsg = false
      // }, 300)
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    checkItem(item) {
      // console.log(item)
      this.editedIndex = this.indexData.modifiedDatas.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    onPageChange() {
      this.PendingPaginationMethod();
    },

    PendingPaginationMethod() {
      // console.log(this.search)
      this.loading = true;
      if (this.indexData.modifiedDatas) {
        if (this.search) {
          this.$store.dispatch("changePaymentStatus", [
            "payment-status",
            3,
            this.search,
            this.indexData.modifiedDatas.current_page,
            this.pagination.rowsPerPage,
          ]);
          this.loading = this.indexData.modifiedDatas.data ? false : true;
        } else {
          this.$store.dispatch("changePaymentStatus", [
            "payment-status",
            3,
            this.search,
            this.indexData.modifiedDatas.current_page,
            this.pagination.rowsPerPage,
          ]);
          this.loading = !this.indexData.error ? false : true;
        }
        this.dialog = false;
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.v-progress-circular
  margin: 1rem

.imageResize
  width: auto
  height: auto
</style>
